export default __webpack_public_path__ + "static/media/bg-manual-top.407781e6.png";